import { GridSortItem } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  GetAllTasksFlagEnum,
  GetAllTasksTaskPriorityEnum,
  GetAllTasksTaskStatusEnum,
  TaskControllerApi,
} from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting: GridSortItem[];
  active?: boolean;
  flag?: GetAllTasksFlagEnum;
  taskPriority?: GetAllTasksTaskPriorityEnum;
  providerTask?: boolean;
  dueDate?: string;
  patient?: string;
  assignTo?: string;
  assignBy?: string;
  myTask?: boolean;
  toDoTask?: boolean;
  archive?: boolean;
  searchString?: string;
  xTENANTID?: string;
  taskStatus?: GetAllTasksTaskStatusEnum;
  startDate?: string;
  endDate?: string;
  appointmentId?: string;
  actionType?: string;
}

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useListTasks = (props: Props): useBaseContent<OptionData> => {
  const prevPage = useRef<number>(props.pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination: props.pagination,
    searchKey: "",
    prevPage,
  });

  const sortData = props.gridSorting?.[0];
  return useQuery({
    queryKey: ["collaboration-task-list", pageIndex, props],

    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new TaskControllerApi(getConfigObject())
        .getAllTasks(
          pageIndex, //page
          props.pagination.pageSize, //size
          sortData?.field, // sortBy
          sortData?.sort ?? undefined, // sortDirection
          props.active, // active
          props.flag, // flag
          props.taskPriority, // taskPriority
          props.providerTask, // providerTask
          props.patient, // patient
          props.assignTo, // assignTo
          props.assignBy, // assignBy
          props.myTask, // myTask
          props.toDoTask, // toDoTask
          props.archive, // archive
          props.dueDate, // dueDate
          props.taskStatus, // taskStatus
          props.searchString, // searchString
          props.startDate, // startDate
          props.endDate, // endDate
          props.appointmentId, // appointmentId
          props.actionType, // actionType
          props.xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
